import { APP_INITIALIZER } from '@angular/core';

import { BootstrapService } from './bootstrap.service';

export function bootstrapServiceFactory(bootstrapService: BootstrapService) {
  return () => bootstrapService.bootstrap();
}

/**
 * Provider that bootstraps the application.
 * */
export const bootstrapProvider = {
  provide: APP_INITIALIZER,
  useFactory: bootstrapServiceFactory,
  deps: [BootstrapService],
  multi: true
};
